import { match } from 'ts-pattern';

import getTaskType from 'lib/common/contexts/ContactContext/utils/getTaskType';

import CONTACT_TYPES from 'lib/common/constants/contactTypes';

import { getAgentVoiceOrChatConnection } from '../../conferenceConnections';
import connectGetter from '../../connectGetter';

export default function isAgentBargedIn(contact: connect.Contact | undefined) {
  const contactType = getTaskType(contact);
  const doesTaskTypeSupportMonitoring = match(contactType)
    .with(
      CONTACT_TYPES.CALL,
      CONTACT_TYPES.QUEUE_CALLBACK,
      CONTACT_TYPES.CONFERENCE_CALL,
      CONTACT_TYPES.CHAT,
      () => true
    )
    .otherwise(() => false);

  if (!doesTaskTypeSupportMonitoring) {
    return false;
  }

  const agentConnection = getAgentVoiceOrChatConnection(contact);

  return connectGetter(agentConnection, 'getMonitorStatus') === connect.MonitoringMode.BARGE;
}
